// Первым — патч fetch для CF-Access-Token, чтобы Sentry при импорте уже использовал обёртку
// import './sentryFetchPatch';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

const dsn = import.meta.env.SENTRY_DSN;

if (typeof dsn === 'string' && dsn.trim().length > 0) {
  const appContext =
    document.querySelector<HTMLMetaElement>('meta[name="app-context"]')?.getAttribute('content')?.trim() ?? 'default';

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
    debug: import.meta.env.MODE === 'development'
  });

  Sentry.setTag('app_context', appContext);
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element #root not found');
}

ReactDOM.createRoot(rootElement).render(<App />);

